import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Landing from './pages/Landing';
import Login from './pages/Login';
import About from './pages/About';
import FAQ from './pages/FAQ';
import AppShell from './components/AppShell';
import Dashboard from './pages/Dashboard';
import TopicDetail from './pages/TopicDetail';
import PartnerDetail from './pages/PartnerDetail';
import Invite from './pages/Invite';
import Profile from './pages/Profile';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/about" element={<About />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/app" element={<AppShell />}>
          <Route index element={<Dashboard />} />
          <Route path="topic/:id" element={<TopicDetail />} />
          <Route path="partner/:id" element={<PartnerDetail />} />
          <Route path="invite" element={<Invite />} />
          <Route path="profile" element={<Profile />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
